import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Autocomplete, Button, TextField, Typography } from '@mui/material';

import { queueVendorLiabilityReport } from '~/services/ReportingService';

import ErrorDisplay from '../ErrorDisplay';

// Grouped by product family; order controls dropdown render order
const OFFER_TYPES = [
  // Accommodation
  'bedbank',
  'bedbank_marriott',
  'custom_offer_hotel',
  'hotel',
  'last_minute_hotel',
  'luxury_plus',
  'rental',
  'tactical_ao_hotel',
  // Cruises
  'cruise',
  'cruisebank',
  'custom_offer_cruise',
  // Experiences
  'addon',
  'custom_offer_experience',
  'dby_exp',
  'led_exp',
  'mus_exp',
  'rez_exp',
  'tour_optional_experience',
  // Tours
  'custom_offer_tour',
  'tour',
  'tourbank',
  // Other
  'car_hire',
  'cfmr',
  'custom_offer_other',
  'flight',
  'insurance',
];

const formSchema: RJSFSchema = {
  description: 'Please enter a date to generate the Vendor Liability Report as at that date (inclusive).',
  type: 'object',
  properties: {
    endAt: {
      title: 'Report Date',
      type: 'string',
      format: 'date',
    },
  },
  required: ['endAt'],
};

const uiSchema = {
  endAt: {
    'ui:widget': 'date',
  },
};

export default function ExportVendorLiabilityReportForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);
  const [offerTypes, setOfferTypes] = useState<Array<string>>([]);

  const handleSubmit = async (event: IChangeEvent) => {
    setError(null);
    setSuccessMessage(false);
    try {
      await queueVendorLiabilityReport({
        endAt: event.formData.endAt,
        offerTypes: offerTypes.length > 0 ? offerTypes : undefined,
      });
      setSuccessMessage(true);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Form schema={formSchema} uiSchema={uiSchema} onSubmit={handleSubmit} validator={validator} showErrorList={false}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={OFFER_TYPES}
        value={offerTypes}
        onChange={(_, newValue) => setOfferTypes(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Product Type"
            placeholder="All types (no filter)"
            InputLabelProps={{ shrink: true }}
          />
        )}
        sx={{ mt: 1, mb: 1 }}
      />

      <Button type="submit" variant="contained">
        Email Vendor Liability Report
      </Button>

      {error && <ErrorDisplay message={error} />}

      {successMessage && (
        <Alert severity="success">
          <Typography>Your report is queued for delivery and will be emailed shortly.</Typography>
        </Alert>
      )}
    </Form>
  );
}
